<template>
  <div
    style="margin-top: 20px; margin-left: 10px; margin-right: 10px; width: 15vm"
  >
    <div style="margin: 10px 20px">
      <div class="image-container">
        <img
          width="100%"
          height="210px"
          :src="record.pic ? record.pic : img"
          alt=""
          class="img1"
        />
      </div>

      <div
        style="
          font-size: 1rem !important;
          font-weight: 700 !important;
          margin-top: 20px;
          margin-left: 8px;
        "
      >
        <span style="color: #0067b3">{{ record.code }}</span>
        {{ record.model }} {{ record.brand }}
      </div>

      <div style="margin-left: 10px; margin-right: 10px">
        <div class="rowStyle">
          <span>{{ $t("accessoriyDetail.品牌") }}</span
          ><span style="float: right">{{ record.brand }}</span>
        </div>

        <div class="rowStyle">
          <span>{{ $t("accessoriyDetail.生产年份") }}</span
          ><span style="float: right">{{ record.factoryDate }}</span>
        </div>
      </div>

      <div
        style="display: flex; justify-content: space-around; padding: 15px 5px"
      >
        <!-- <div style="display: flex; justify-content: flex-start; flex: 5">
          <div>
            <img width="28px" src="../img/bofang.png" alt="" />
          </div>
        </div> -->
        <div
          style="
            display: flex;
            justify-content: right;
            padding-right: 15px;
            flex: 5;
            color: rgb(255, 166, 10);
          "
          v-if="$store.state.userInfo.length > 0"
        >
          {{ $t("accessoriyDetail.登录后查询价格") }}
        </div>
      </div>

      <div style="display: flex">
        <a class="DetailStyle" @click="clickDetail(record.id)">{{
          $t("accessoriyDetail.详情")
        }}</a>
        <a class="InquireStyle" @click="clickQuotation()">{{
          $t("accessoriyDetail.询价")
        }}</a>
        <quotation ref="quotation"></quotation>
      </div>
    </div>
  </div>
</template>

<script>
// import Router from "vue-router";
import quotation from "./quotation.vue";
import { getBucket } from "../utils/util";
export default {
  components: { quotation },
  props: {
    record: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return { img: require("../img/wtupian.png") };
  },
  mounted() {
    console.log(this.record.pic, "=========this.record.pic");
    this.getImg(this.record.id);
  },
  watch: {
    record(newValue, oldValue) {
      this.getImg(newValue.id);
    },
  },
  methods: {
    favourite() {
      if (this.$store.state.userInfo.name == "登录") {
        this.login();
      } else {
        let arr = [];
        arr = this.$store.state.favoriteList;
        //alert(this.$store.state.favoriteList);
        if (arr.filter((item) => item.id == this.record.id).length <= 0) {
          arr.push(this.record);
          this.$store.dispatch("setFavoriteMessage", arr);
          localStorage.setItem("favoriteJson", JSON.stringify(arr));
          //this.$refs.shoucang.src = require("../img/bofang.png");
          this.$message.info("收藏成功");
        } else {
          this.$message.info("重复收藏");
        }
      }
    },
    compare() {
      if (this.$store.state.userInfo.name == "登录") {
        this.login();
      } else {
        let arr = [];
        arr = this.$store.state.bijiaoList;
        //alert(this.$store.state.favoriteList);
        if (arr.filter((item) => item.id == this.record.id).length <= 0) {
          arr.push(this.record);
          this.$store.dispatch("setbijiaoMessage", arr);
          localStorage.setItem("bijiaoJson", JSON.stringify(arr));
          //this.$refs.shoucang.src = require("../img/bofang.png");
          this.$message.info("加入比较成功");
        } else {
          this.$message.info("重复加入比较");
        }
      }
    },
    getImg(id) {
      getBucket("basic/", id).then((res) => {
        this.$set(this.record, "pic", res[0]);
      });
    },
    clickQuotation() {
      // if (this.$store.state.userInfo.name == "登录") {
      //   this.login();
      // } else {
      this.$refs.quotation.show({ type: "fork", record: this.record });
      //}
    },
    clickDetail(id) {
      this.$router.push({
        path: "/accessoriyDetail",
        query: { id: id },
      });
      if (this.$route.name == "accessoriyDetail") {
        this.$emit("getID", id);
      }
    },
  },
};
</script>

<style scoped>
.rowStyle {
  display: flex;
  justify-content: space-between;
}
.div_align {
  text-align: center;
}
.image-container {
  position: relative;
  /* 相对定位，使内部absolute定位的元素相对于此容器定位 */
  display: inline-block;
  /* 使div像inline-element一样表现，便于内部元素的定位 */
}

.image-container img {
  display: block;
  /* 防止图片下方出现空隙 */

  /* 或其他宽度 */
}
.img1 {
  object-fit: cover; /* 不会变形，但可能裁剪图片 */
}

.image-container .icon {
  position: absolute;
  /* 绝对定位 */
  top: 5px;
  /* 定位到图片的顶部 */
  right: 0px;
  /* 定位到图片的右侧 */
  font-size: 20px;
  /* 图标大小 */
  font-size: 12px;
  /* 标签字体大小 */
}

.icon-div1 {
  display: flex;
  font-size: 12px;
  font-weight: 700;
  color: #f3f3f3;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 30px;

  margin-bottom: 5px;
  clip-path: polygon(
    10% 0%,

    100% 0%,
    100% 100%,
    100% 100%,
    10% 100%,
    0% 50%
  );
  background-color: #0067b3;
}

.icon-div2 {
  display: flex;
  font-size: 12px;
  font-weight: 700;
  color: #0067b3;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 30px;

  margin-bottom: 5px;
  clip-path: polygon(
    10% 0%,

    100% 0%,
    100% 100%,
    100% 100%,
    10% 100%,
    0% 50%
  );
  background-color: #f3f3f3;
}

.DetailStyle {
  font-weight: 400;
  color: #f3f3f3;
  font-size: 1.25rem;
  display: flex;
  justify-content: center;
  flex: 5;
  height: 50px;
  background-color: #1890ff;
  align-items: center;
}

.InquireStyle {
  font-weight: 400;
  color: #f3f3f3;
  font-size: 1.25rem;
  display: flex;
  justify-content: center;
  flex: 5;
  height: 50px;
  background-color: #0067b3;
  align-items: center;
}
</style>
